// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_WGA","cls2":"NewCitationPing-cls2_u-N NewCitationPing-cls1_WGA"};